/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import BaseStep from './BaseStep';

class RenderBadgesInfo extends BaseStep{
	process(/*renderContext*/) {
		// Render is complete. Update the slot badge decorations.
		this.badgesFeature.renderBadges();
		return Promise.resolve();
	}
}
export default RenderBadgesInfo;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-badges/src/js/rendersequence/RenderBadgesInfo.js